// import { useParams, Link } from "react-router-dom";
// import { useEffect, useState } from "react";
// import {
//   fetchTopicsBySubject,
//   createTopic,
//   deleteTopic,
//   fetchDates,
//   createDate,
//   updateDate,
//   deleteDate,
// } from "../utils/api";

// export default function Topics() {
//   const { slug } = useParams();
//   const [topics, setTopics] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
// const [editingTopic, setEditingTopic] = useState(null);
// const [dates, setDates] = useState([]);
// const [newDate, setNewDate] = useState("");
// const [editingDate, setEditingDate] = useState(null);



//   const [form, setForm] = useState({
   
//     title_he: "",
//    date:""
//   });
// const loadDates = async () => {
//   try {
//     const data = await fetchDates();
//     setDates(data);
//   } catch (e) {
//     console.error(e);
//   }
// };

//   const loadTopics = async () => {
//     try {
//       const data = await fetchTopicsBySubject(slug);
//       setTopics(data);
//     } catch (err) {
//       console.error("Failed to load topics", err);
//     } finally {
//       setLoading(false);
//     }
//   };

// useEffect(() => {
//   loadTopics();
//   loadDates();
// }, [slug]);


//   // useEffect(() => {
//   //   loadTopics();
//   // }, [slug]);

//   // const handleCreate = async () => {
//   //   if (!form.title_he) return alert("Hebrew title required");

//   //   try {
//   //     await createTopic({ subjectSlug:slug, ...form });
//   //     setForm({  title_he: ""});
//   //     loadTopics();
//   //   } catch (err) {
//   //     alert(err.message);
//   //   }
//   // };

//   const handleCreate = async () => {
//   try {
//     await createTopic({ subjectSlug: slug, ...form });
//     setForm({ title_he: "" });
//     loadTopics();
//   } catch (err) {
//     alert(err.message);
//     throw err;
//   }
// };

//   const handleDelete = async (id) => {
//     if (!confirm("Delete this topic?")) return;
//     try {
//       await deleteTopic(id);
//      await loadTopics();
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   return (
//     <div className="users-page">
//       {/* Header */}
//       <div className="page-header">
//         <h1 className="page-title">Topics</h1>
//         <p className="page-subtitle">
//           Subject: <strong>{slug}</strong>
//         </p>
//       </div>
// {slug === "tzaddikim" && (
//   <div className="mt-4 border-t pt-4">
//     <h3 className="text-sm font-semibold mb-2">Manage Dates</h3>

//     <div className="flex gap-2">
//       <input
//         placeholder="New date"
//         value={newDate}
//         onChange={(e) => setNewDate(e.target.value)}
//         className="flex-1 border rounded-md p-2"
//       />
//       <button
//         className="action-btn activate"
//         onClick={async () => {
//           if (!newDate) return;
//           await createDate(newDate);
//           setNewDate("");
//           loadDates();
//         }}
//       >
//         Add
//       </button>
//     </div>

//     <ul className="mt-3 space-y-2">
//       {dates.map((d) => (
//         <li key={d.date} className="flex justify-between items-center">
//           {editingDate === d.date ? (
//             <>
//               <input
//                 defaultValue={d.date}
//                 onBlur={async (e) => {
//                   await updateDate(d.date, e.target.value);
//                   setEditingDate(null);
//                   loadDates();
//                 }}
//                 className="border rounded-md p-1"
//                 autoFocus
//               />
//             </>
//           ) : (
//             <>
//               <span>{d.date}</span>
//               <div className="flex gap-2">
//                 <button
//                   className="action-btn"
//                   onClick={() => setEditingDate(d.date)}
//                 >
//                   Edit
//                 </button>
//                 <button
//                   className="action-btn deactivate"
//                   onClick={async () => {
//                     if (!confirm("Delete date?")) return;
//                     await deleteDate(d.date);
//                     loadDates();
//                   }}
//                 >
//                   Delete
//                 </button>
//               </div>
//             </>
//           )}
//         </li>
//       ))}
//     </ul>
//   </div>
// )}

//       {/* ADD TOPIC */}
//      <div className="page-header">
//   <button
//     className="action-btn activate"
//     onClick={() => setShowModal(true)}
//   >
//     + Add Topic
//   </button>
// </div>

// {showModal && (
//   <div
//     style={{
//       position: "fixed",
//       inset: 0,
//       background: "rgba(0,0,0,0.4)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       zIndex: 50,
//     }}
//   >
//     <div
//       style={{
//         background: "white",
//         borderRadius: "12px",
//         width: "420px",
//         padding: "24px",
//         boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
//       }}
//     >
//       <h2 className="page-title" style={{ fontSize: "18px" }}>
//         Add New Topic
//       </h2>

//       <p className="page-subtitle">
//         Subject: <strong>{slug}</strong>
//       </p>

//       <div className="form-group">
//         <label>Topic Name</label>
//         <input
//           autoFocus
//           placeholder="Enter topic name"
//           value={form.title_he}
//           onChange={(e) =>
//             setForm({ ...form, title_he: e.target.value })
//           }
//         />
//       </div>
//         {slug === "tzaddikim" && (
//   <div className="mt-4">
//     <label className="text-sm font-semibold mb-1 block">
//       Date
//     </label>

//     <select
//       value={form.date}
//       onChange={(e) =>
//         setForm({ ...form, date: e.target.value })
//       }
//       className="w-full border rounded-md p-2"
//     >
//       <option value="">Select date</option>
//       {dates.map((d) => (
//         <option key={d.date} value={d.date}>
//           {d.date}
//         </option>
//       ))}
//     </select>
//   </div>
// )}

//       <div
//         style={{
//           display: "flex",
//           justifyContent: "flex-end",
//           gap: "10px",
//           marginTop: "20px",
//         }}
//       >
//         <button
//           className="action-btn"
//           onClick={() => {
//             setShowModal(false);
//             setForm({ title_he: "" });
//           }}
//         >
//           Cancel
//         </button>

//         <button
//           className="action-btn activate"
//           onClick={async () => {
//             if (!form.title_he) return alert("Topic name required");

//             await handleCreate();
//             setShowModal(false);
//           }}
//         >
//           Add Topic
//         </button>
//       </div>
//     </div>
//   </div>
// )}

//       {/* TOPICS LIST */}
//       <div className="table-wrapper">
//         <table className="users-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Topic Name</th>
//               {/* <th>English</th>
//               <th>Yiddish</th> */}
//               {slug === "tzaddikim" && <th>Date</th>}
//               <th>Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {loading ? (
//               <tr>
//                 <td colSpan="5" className="empty">
//                   Loading topics…
//                 </td>
//               </tr>
//             ) : topics.length === 0 ? (
//               <tr>
//                 <td colSpan="5" className="empty">
//                   No topics found
//                 </td>
//               </tr>
//             ) : (
//               topics.map((t, index) => (
//                 <tr key={t.id}>
//                   <td>{index + 1}</td>
//                   <td dir="rtl">{t.title_he}</td>
//                   {/* <td>{t.title_en}</td> */}
//                   {/* <td dir="rtl">{t.title_yi}</td> */}
//                    {slug === "tzaddikim" && <td>{t.date}</td>}
//                   <td className="flex gap-4">
//                     <Link
//                       to={`/stories/${t.id}`}
//                       className="action-btn activate"
//                     >
//                       Stories
//                     </Link>
// <button
//   onClick={() => {
//     setEditingTopic(t);
//     setForm({
//       title_he: t.title_he || "",
//       date: t.date || "",
//     });
//     setShowModal(true);
//   }}
//   className="action-btn"
// >
//   Edit
// </button>

//                     <button
//                       onClick={() => handleDelete(t.id)}
//                       className="action-btn deactivate"
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
      
//     </div>
    
//   );
// }

import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  DndContext,
  closestCenter,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
// import { updateDateOrder } from "../utils/api";

import {
  fetchTopicsBySubject,
  createTopic,
  updateTopic,
  deleteTopic,
  fetchDates,
  createDate,
  updateDate,
  updateDateOrder,
  deleteDate,
} from "../utils/api";


export default function Topics() {
  const { slug } = useParams();

  const [topics, setTopics] = useState([]);
  const [dates, setDates] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [editingTopic, setEditingTopic] = useState(null);

  const [newDate, setNewDate] = useState("");
  const [editingDate, setEditingDate] = useState(null);

  const [form, setForm] = useState({
    title_he: "",
    date: "",
  });

  /* ---------------- LOADERS ---------------- */
  const loadTopics = async () => {
    try {
      const data = await fetchTopicsBySubject(slug);
      setTopics(data);
    } finally {
      setLoading(false);
    }
  };

  // const loadDates = async () => {
  //   const data = await fetchDates();
  //   setDates(data);
  // };
  const loadDates = async () => {
  const data = await fetchDates();
  setDates(data.sort((a, b) => a.order - b.order));
};


  useEffect(() => {
    loadTopics();
    loadDates();
  }, [slug]);

  /* ---------------- SAVE TOPIC ---------------- */
  const handleSave = async () => {
    if (!form.title_he) return alert("Topic name required");

    if (editingTopic) {
      await updateTopic(editingTopic.id, form);
    } else {
      await createTopic({ subjectSlug: slug, ...form });
    }

    setShowModal(false);
    setEditingTopic(null);
    setForm({ title_he: "", date: "" });
    loadTopics();
  };

  /* ---------------- DELETE TOPIC ---------------- */
  const handleDelete = async (id) => {
    if (!confirm("Delete this topic?")) return;
    await deleteTopic(id);
    loadTopics();
  };
function SortableRow({ d, editingDate, setEditingDate, loadDates }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: d.date });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style}>
      <td {...attributes} {...listeners} style={{ cursor: "grab" }}>
        ⠿ {d.date}
      </td>
      <td className="flex gap-2">
        <button
          className="action-btn"
          onClick={() => setEditingDate(d.date)}
        >
          Edit
        </button>
        <button
          className="action-btn deactivate"
          onClick={async () => {
            if (!confirm("Delete date?")) return;
            await deleteDate(d.date);
            loadDates();
          }}
        >
          Delete
        </button>
      </td>
    </tr>
  );
}

  return (
    <div className="users-page">
      {/* HEADER */}
      <div className="page-header">
        <h1 className="page-title">Topics</h1>
        <p className="page-subtitle">
          Subject: <strong>{slug}</strong>
        </p>
      </div>

      {/* ---------------- DATE MANAGEMENT ---------------- */}
      {slug === "tzaddikim" && (
        <div className="mt-6">
          <h3 className="text-sm font-semibold mb-2">Manage Dates</h3>

          <div className="flex gap-2 mb-3">
            <input
              placeholder="New date"
              value={newDate}
              onChange={(e) => setNewDate(e.target.value)}
              className="flex-1 border rounded-md p-2"
            />
            <button
              className="action-btn activate"
              onClick={async () => {
                if (!newDate) return;
                await createDate(newDate);
                setNewDate("");
                loadDates();
              }}
            >
              Add
            </button>
          </div>

          <div className="table-wrapper small-table">
            <table className="users-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
               <DndContext
  collisionDetection={closestCenter}
  onDragEnd={async (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = dates.findIndex(d => d.date === active.id);
    const newIndex = dates.findIndex(d => d.date === over.id);

    const updated = [...dates];
    const [moved] = updated.splice(oldIndex, 1);
    updated.splice(newIndex, 0, moved);

    // Update UI instantly
    setDates(updated);

    // Persist order
    await updateDateOrder(
      updated.map((d, i) => ({
        date: d.date,
        order: i,
      }))
    );
  }}
>
  <SortableContext
    items={dates.map(d => d.date)}
    strategy={verticalListSortingStrategy}
  >
    <tbody>
      {dates.map((d) => (
        <SortableRow
          key={d.date}
          d={d}
          editingDate={editingDate}
          setEditingDate={setEditingDate}
          loadDates={loadDates}
        />
      ))}
    </tbody>
  </SortableContext>
</DndContext>

              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ---------------- ADD TOPIC BUTTON ---------------- */}
      <div className="page-header">
        <button
          className="action-btn activate"
          onClick={() => {
            setEditingTopic(null);
            setForm({ title_he: "", date: "" });
            setShowModal(true);
          }}
        >
          + Add Topic
        </button>
      </div>

      {/* ---------------- MODAL ---------------- */}
      {showModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 50,
    }}
  >
    <div
      style={{
        background: "white",
        borderRadius: "12px",
        width: "420px",
        padding: "24px",
        boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
      }}
    >
      <h2 className="page-title" style={{ fontSize: "18px" }}>
        Add New Topic
      </h2>

      <p className="page-subtitle">
        Subject: <strong>{slug}</strong>
      </p>

      <div className="form-group">
        <label>Topic Name</label>
        <input
          autoFocus
          placeholder="Enter topic name"
          value={form.title_he}
          onChange={(e) =>
            setForm({ ...form, title_he: e.target.value })
          }
        />
      </div>
        {slug === "tzaddikim" && (
  <div className="mt-4">
    <label className="text-sm font-semibold mb-1 block">
      Date
    </label>

    <select
      value={form.date}
      onChange={(e) =>
        setForm({ ...form, date: e.target.value })
      }
      className="w-full border rounded-md p-2"
    >
      <option value="">Select date</option>
      {dates.map((d) => (
        <option key={d.date} value={d.date}>
          {d.date}
        </option>
      ))}
    </select>
  </div>
)}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <button
          className="action-btn"
          onClick={() => {
            setShowModal(false);
            setForm({ title_he: "" });
          }}
        >
          Cancel
        </button>

        <button
          className="action-btn activate"
        onClick={handleSave}
        >
          {editingTopic ? "Update Topic" : "Add Topic"}
        </button>
      </div>
    </div>
  </div>
)}
      {/* {showModal && (
        <div className="modal-backdrop">
          <div className="modal-box">
            <h2 className="page-title">
              {editingTopic ? "Edit Topic" : "Add Topic"}
            </h2>

            <div className="form-group">
              <label>Topic Name</label>
              <input
                autoFocus
                value={form.title_he}
                onChange={(e) =>
                  setForm({ ...form, title_he: e.target.value })
                }
              />
            </div>

            {slug === "tzaddikim" && (
              <div className="mt-4">
                <label className="text-sm font-semibold mb-1 block">
                  Date
                </label>
                <select
                  value={form.date}
                  onChange={(e) =>
                    setForm({ ...form, date: e.target.value })
                  }
                  className="w-full border rounded-md p-2"
                >
                  <option value="">Select date</option>
                  {dates.map((d) => (
                    <option key={d.date} value={d.date}>
                      {d.date}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="modal-actions">
              <button
                className="action-btn"
                onClick={() => {
                  setShowModal(false);
                  setEditingTopic(null);
                }}
              >
                Cancel
              </button>
              <button className="action-btn activate" onClick={handleSave}>
                {editingTopic ? "Update Topic" : "Add Topic"}
              </button>
            </div>
          </div>
        </div>
      )} */}

      {/* ---------------- TOPICS TABLE ---------------- */}
      <div className="table-wrapper">
        <table className="users-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Topic</th>
              {slug === "tzaddikim" && <th>Date</th>}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="empty">
                  Loading…
                </td>
              </tr>
            ) : topics.length === 0 ? (
              <tr>
                <td colSpan="4" className="empty">
                  No topics
                </td>
              </tr>
            ) : (
              topics.map((t, i) => (
                <tr key={t.id}>
                  <td>{i + 1}</td>
                  <td dir="rtl">{t.title_he}</td>
                  {slug === "tzaddikim" && <td>{t.date}</td>}
                  <td className="flex gap-2">
                    <Link
                      to={`/stories/${t.id}`}
                      className="action-btn activate"
                    >
                      Stories
                    </Link>
                    <button
                      className="action-btn"
                      onClick={() => {
                        setEditingTopic(t);
                        setForm({
                          title_he: t.title_he || "",
                          date: t.date || "",
                        });
                        setShowModal(true);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="action-btn deactivate"
                      onClick={() => handleDelete(t.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
